<template>
<div style="text-align: center;">
   <el-button @click="toLogin1">进入录题系统</el-button>
</div>
</template>

<script>
import Vue from "vue";
import QRCode from 'qrcodejs2'
import AV from "leancloud-storage";
import LoginSessionToken from "../../model/loginSessionToken";
import Token from "../../model/token";

export default {
    data() {
        return {
            url: '',
        }
    },

    created() {
        this.getData();

    },
    methods: {
    toLogin1(){
            AV.User.logIn('Tom', 'cat!@#123').then((user) => {
            // 登录成功
                var self = this;
                self.$router.push({
                    path:'/'
                })
            }, (error) => {
            // 登录失败（可能是密码错误）
            });
			// AV.User.loginAnonymously().then(()=>{
            //     var self = this;
            //     self.$router.push({
            //         path:'/'
            //     })
            // })
			// console.log(11)
			// AV.User.logIn('我是游客', '123456').then((user) => {
			// 	self.$router.push({
			//      path: "/"
			// 	});
			// }, (error) => {
			//  console.log(error)
			// });
		},
        getData() {

            console.log(111111111111);
            let loginSessionToken = new LoginSessionToken();
            loginSessionToken.token = 'login';
            loginSessionToken.save().then(session => {

                let qrcode = new QRCode('qrcode', {
                    width: 200,
                    height: 200,
                    text: loginSessionToken.id, // 二维码地址
                    colorDark: "#000",
                    colorLight: "#fff",
                })

                //监测
                var self = this;

                let aa = setInterval(function () {

                    session.fetch().then(ss => {

                      

                        if (ss.sessionToken.length > 0) {
                            //登录成功
                              console.log(ss)
                            AV.User.become(ss.sessionToken).then(function (user) {

                                console.log(user)

                                if (user.get('role') == '1999' || user.get('role') == '1998') {
                                    clearInterval(aa);

                                    let license = user.get('username').split('-')[0];

                                    //存储
                                    localStorage.setItem('license', license)

                                    new AV.Query(Token).equalTo('license', license).first().then(token => {

                                        localStorage.setItem('intro', token.intro)
                                        self.$router.push({
                                            path: "/"
                                        });
                                    })
                                } else {
                                    this.$message.error('非管理员不能登录');

                                }

                            }).catch(err => {
                                console.log(err);
                            })
                        }
                    })

                }, 2000)
            }).catch(err => {
                console.log(err);
            });

        },

    }
}
</script>
